import { render } from "./UserBirthday.vue?vue&type=template&id=59f2060f"
import script from "./UserBirthday.vue?vue&type=script&lang=js"
export * from "./UserBirthday.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__